module.exports = "/assets/0ddc3e6b030027df3a592a7e3f696f9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/B6.png
// module id = 1219
// module chunks = 0